module.exports = __webpack_public_path__ + "img/public/SiteIcons/xIconBlack.svg?53907d45";